import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'mc-notification-link',
  templateUrl: './notification-link.component.html',
})
export class NotificationLinkComponent {
  @Input() link: string;
  @Input() content: string;
  @Output() linkClick = new EventEmitter();
  onLinkClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.linkClick.emit(event);
  }
}
